import { MessagingService } from './../messaging.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { TabsetComponent, TabDirective } from 'ngx-bootstrap/tabs';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  currentMessage = new BehaviorSubject('');
  disableSwitching: boolean;
  @ViewChild('tabset') tabset: TabsetComponent;
  @ViewChild('merchant') merchant: TabDirective;
  @ViewChild('visitor') visitor: TabDirective;
  @ViewChild('fellowships') fellowships: TabDirective;
  user: any;
  text: any;
  bussinessHours: any;
  userImage: any;
  perpetualAdd: any;
  weeklyTime = [];
  visitors: any;
  inquiries: any[] = [];
  followers: any;
  loading = false;
  show: any;
  slideConfig = { slidesToShow: 4, slidesToScroll: 4, infinite: false };
  imageObject = [];
  photoGallery = [];
  url: any;
  activeTab = 'merchant';
  showSpinner: Boolean = true;
  merchantDetail;
  spinnerType = SPINNER.circle;
  businessType: any;
  isHideAddress: false;
  isSubStatus = true;
  allPlans: Array<any> = [];
  profileUrl;
  userName: any;
  isModalVisible = false;
  doNotShowAgain = true;
  isUserLoggedIn: any;
  // Server-driven controls for subscribe modal visibility
  dontShowSubscribeModal?: boolean;
  dontShowSubscribeModalUntil?: string;

  constructor(
    public router: Router,
    private ngxService: NgxUiLoaderService,
    private messageService: MessagingService,
    public authenticationService: AuthenticationService,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.userName = this.messageService.getValue().subscribe((res) => {
      return res;
    })
  }

  get newInquiriesCount(): number {
    return (this.inquiries || []).filter((i: any) => i.status === 'new').length;
  }

  ngOnInit(): void {
    this.isUserLoggedIn = localStorage.getItem('merchant_id') !== null;
    this.url = environment.basePath;
    this.merchantDetail = this.authenticationService.currentUserValue;

    // ② read stored expiry (local fallback)
    const hideUntil = localStorage.getItem('hideModalUntil');
    if (hideUntil && new Date(hideUntil) > new Date()) {
      this.doNotShowAgain = true;
    } else {
      localStorage.removeItem('hideModalUntil');
      this.doNotShowAgain = false;
    }

    // kick off all your loads
    this.getUserProfile();
    this.getVisitors();
    this.getFollowers();
    this.getInquiries();
    this.hideAddress(this.user);
    localStorage.removeItem('email');
    localStorage.removeItem('affiliationData');
    this.onGallery();
  }

  openModal(): void {
    this.isModalVisible = true;
  }

  closeModal(): void {
    this.isModalVisible = false;
    const videoFrame = document.getElementById('videoFrame') as HTMLIFrameElement;

    videoFrame.src = '';
  }
  onBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeModal();
    }
  }

  handleDoNotShow(event: Event): void {
    const checkbox = (event.target as HTMLInputElement);
    this.doNotShowAgain = checkbox.checked;
    if (this.doNotShowAgain) {
      // Persist preference to backend; also set local fallback expiry
      this.authenticationService.postData('/merchant/hide-subscribe-modal', {})
        .subscribe(
          () => {
            const expiry = new Date();
            expiry.setMonth(expiry.getMonth() + 1); // +1 month
            localStorage.setItem('hideModalUntil', expiry.toISOString());
            this.isModalVisible = false;
          },
          () => {
            // Fallback to local-only persistence on failure
            const expiry = new Date();
            expiry.setMonth(expiry.getMonth() + 1);
            localStorage.setItem('hideModalUntil', expiry.toISOString());
            this.isModalVisible = false;
          }
        );
    } else {
      localStorage.removeItem('hideModalUntil');
      // if they uncheck, maybe re-show next time you re-load profile
    }
  }

  checkModalVisibility(): void {
    // Re-evaluate using server flags; falls back to local expiry if server flags missing
    if (this.shouldShowSubscribeModal()) {
      this.openModal();
    } else {
      this.isModalVisible = false;
    }
  }

  private shouldShowSubscribeModal(): boolean {
    // Never show if already subscribed
    if (this.merchantDetail?.hasSubscription) {
      return false;
    }
    // Prefer server-driven flags if present
    if (typeof this.dontShowSubscribeModal === 'boolean') {
      const until = this.dontShowSubscribeModalUntil ? new Date(this.dontShowSubscribeModalUntil) : null;
      const now = new Date();
      if (this.dontShowSubscribeModal === true && until && until > now) {
        return false; // server says hide until future date
      }
    }
    // Fallback to local flag if server flags absent or expired
    const hideUntil = localStorage.getItem('hideModalUntil');
    if (hideUntil && new Date(hideUntil) > new Date()) {
      return false;
    }
    // Otherwise show when not subscribed
    return true;
  }

  openSubscription() {
    this.router.navigateByUrl('/mysubscration?isSub=true');
    this.closeModal();
  }
  logout() {
    this.router.navigateByUrl('/login');
    this.authenticationService.logout();
  }

  getUserProfile(): void {
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        this.businessType = [];
        this.merchantDetail = response.data;
        // Update server-driven modal flags
        this.dontShowSubscribeModal = response?.data?.dontShowSubscribeModal;
        this.dontShowSubscribeModalUntil = response?.data?.dontShowSubscribeModalUntil;
        // Decide to show/hide based on server flags first, then local fallback
        if (this.shouldShowSubscribeModal()) {
          this.openModal();
        } else {
          this.isModalVisible = false;
        }
        this.perpetualAdd = response.data.perpetualAdd;
        this.isHideAddress = response?.data?.address?.isHide
        this.profileUrl = environment.profileUrl + response?.data?.businessUserName

        this.merchantDetail.bussinessTypes.forEach((e) => {
          this.businessType.push(e.tagName);
        });
        this.businessType = this.businessType.join(',');

        this.getDays(this.merchantDetail.bussinessHours);
        this.userImage = this.merchantDetail.photo;
        this.loading = true;
        if (response?.data?.subscriptionPlanType) {
          this.subscriptionPlans(this.isSubStatus, response?.data?.subscriptionPlanType);
        }
      },
      (error) => {
        if (error.error.message == 'Unauthorized') {
          this.authenticationService.logout();
        }
      }
    );
  }

  public subscriptionPlans(val: any, subscriptionPlanType: any): void {
    this.authenticationService.getPlan(val).subscribe(
      (response: any) => {
        this.allPlans = response['data'];

        let order: Object = {
          "Congregational": 1,
          'Business Builder': 2,
          "Business Quarterly": 3,
          "Community Builder": 4,
          "Founder": 5
        }
        this.allPlans = response['data'].sort(function (a, b) {
          return order[a.caption] - order[b.caption];
        });
        if (this.allPlans?.length > 0) {
          let currentPlanDetail = this.allPlans.filter(item => item._id === subscriptionPlanType)
          if (currentPlanDetail?.length > 0) {
            localStorage.setItem('planDetail', JSON.stringify(currentPlanDetail[0]));
          }
        }
        this.loading = true
      },
      error => {
        if (error.error.message == "Unauthorized") {
          this.authenticationService.logout();
        }
      }
    );
  }

  onGallery() {
    this.authenticationService.onphotoGallery().subscribe(
      (res: any) => {
        this.photoGallery = res.data.images;
        this.photoGallery.forEach((e) => {
          this.imageObject.push({
            image: this.renderImage(e),
            thumbImage: this.renderImage(e),
          });
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getVisitors(): void {
    this.ngxService.start();
    this.authenticationService.getVisitors().subscribe(
      (response: any) => {
        this.visitors = response.data;

        // Swal.fire()
        this.ngxService.stop();
      },
      (error) => {
        if (error) {
          this.ngxService.stop();
        }
      }
    );
  }
  checkImage(usr) {
    if (usr) {
      let pathArray = usr.split('/');
      let protocol = pathArray[0];
      let host = pathArray[2];
      let url = protocol + '//' + host + '/';
      if (
        url == environment.basePath &&
        (protocol == 'https:' || protocol == 'http:')
      ) {
        return usr;
      } else if (protocol == 'uploads') {
        return environment.basePath + usr;
      } else {
        return usr;
      }
    }
  }

  getDays(days) {
    if (days && days.Sunday.length > 0) {
      for (let i = 0; i < days.Sunday.length; i++) {
        this.weeklyTime.push({
          name: 'Sunday',
          start: days.Sunday[i].Start,
          finish: days.Sunday[i].Finish,
        });
      }
    }
    if (days && days.Monday.length > 0) {
      for (let i = 0; i < days.Monday.length; i++) {
        this.weeklyTime.push({
          name: 'Monday',
          start: days.Monday[i].Start,
          finish: days.Monday[i].Finish,
        });
      }
    }
    if (days && days.Tuesday.length > 0) {
      for (let i = 0; i < days.Tuesday.length; i++) {
        this.weeklyTime.push({
          name: 'Tuesday',
          start: days.Tuesday[i].Start,
          finish: days.Tuesday[i].Finish,
        });
      }
    }
    if (days && days.Wednesday.length > 0) {
      for (let i = 0; i < days.Wednesday.length; i++) {
        this.weeklyTime.push({
          name: 'Wednesday',
          start: days.Wednesday[i].Start,
          finish: days.Wednesday[i].Finish,
        });
      }
    }
    if (days && days.Thursday.length > 0) {
      for (let i = 0; i < days.Thursday.length; i++) {
        this.weeklyTime.push({
          name: 'Thursday',
          start: days.Thursday[i].Start,
          finish: days.Thursday[i].Finish,
        });
      }
    }
    if (days && days.Friday.length > 0) {
      for (let i = 0; i < days.Friday.length; i++) {
        this.weeklyTime.push({
          name: 'Friday',
          start: days.Friday[i].Start,
          finish: days.Friday[i].Finish,
        });
      }
    }
    if (days && days.Saturday.length > 0) {
      for (let i = 0; i < days.Saturday.length; i++) {
        this.weeklyTime.push({
          name: 'Saturday',
          start: days.Saturday[i].Start,
          finish: days.Saturday[i].Finish,
        });
      }
    }
  }
  getFollowers(): void {
    this.ngxService.start();
    this.authenticationService
      .getFollowers({ skip: '0', limit: '20' })
      .subscribe(
        (response: any) => {
          this.followers = response.items;
          // Swal.fire()
          this.ngxService.stop();
        },
        (error) => {
          if (error) {
            this.ngxService.stop();
          }
        }
      );
  }

  getInquiries(): void {
    this.authenticationService.getMerchantInquiries().subscribe(
      (response: any) => {
        // responseHelper puts payload in "message" (as seen in your API responses)
        this.inquiries = response?.message || response?.data || [];
      },
      (error) => {
        console.log(error);
      }
    );
  }

  markInquirySeen(inquiry: any): void {
  if (inquiry.status !== 'new') { return; } // already seen, skip API call
  this.authenticationService.updateInquiryStatus({
    inquiryId: inquiry._id,
    status: 'seen'
  }).subscribe(
    () => {
      inquiry.status = 'seen'; // update locally, instant UI feedback
    },
    (error) => console.log(error)
  );
}

replyToInquiry(inquiry: any): void {
  // Mark as resolved once merchant replies
  this.authenticationService.updateInquiryStatus({
    inquiryId: inquiry._id,
    status: 'resolved'
  }).subscribe(
    () => { inquiry.status = 'resolved'; },
    (error) => console.log(error)
  );

  const email = inquiry.user?.email;
  if (email) {
    const subject = encodeURIComponent('Re: Your inquiry on Ravel.Faith');
    const body = encodeURIComponent(
      `Hi ${inquiry.user?.name || inquiry.user?.userName || ''},\n\nThank you for reaching out. Regarding your message:\n"${inquiry.message}"\n\n`
    );
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  } else {
    Swal.fire('Info', 'This user\'s email is not available.', 'info');
  }
}

  redirectTo(type) {
    if (type == 1) {
      if (this.merchantDetail.hasSubscription == true) {
      } else {
        this.router.navigate(['/plans'], { queryParams: { isSub: true } });
      }
    } else if (type == 2 && this.merchantDetail.isFirstUpdateDone == true) {
      this.router.navigateByUrl('/user-registration');
    }
  }

  daysToggle() {
    this.show = !this.show;
  }
  changeTab(id) {
    this.tabset.tabs[id].active = true;
  }
  confirmTabSwitch($event) {
    if (this.disableSwitching) {
      const confirm = window.confirm('Discard changes and switch tab?');
      console.log(confirm);
      if (confirm) {
        this.disableSwitching = false;
        this.visitor.active = true;
      }
    }
  }

  getScrollTo(id: string) {
    this.activeTab = id;
    const element = this.getElementById(id);
  }

  getElementById(id: string): HTMLElement {
    const element = <HTMLElement>document.querySelector(`#${id}`);
    return element;
  }

  renderImage(props) {
    if (props) return this.authenticationService.spilturl(props);
  }
  getValidation(props) {
    if (props == undefined || props == '' || props == null) {
      return false;
    }
    return true;
  }
  clickme() {
    this.router.navigateByUrl('/perpetual-add');
  }

  objectKeys(obj: any) {
    return Object.keys(obj);
  }


  hideAddress(event: any) {
    this.isHideAddress = event.target.checked;
    this.updateProfileAddress(this.isHideAddress);
  }

  updateProfileAddress(value: any) {
    let obj = {
      _id: this.merchantDetail._id,
      isHide: value
    }
    this.authenticationService.hideMerchantAddress(obj).subscribe(
      (res) => {
        Swal.fire({
          icon: 'success',
          title: 'Display Address Updated',
        }
        )
      },
      (error) => {
        console.log(error.error);
        Swal.fire('Error', error.error.message, 'error');
      }
    );
  }

  goToUrl() {
    window.open(this.profileUrl, "_blank");
  }

  onImgError(event: Event, fallbackSrc: string) {
    const img = event?.target as HTMLImageElement | null;
    if (!img) return;
    // prevent infinite loop if fallback also fails
    if (img.getAttribute('data-fallback-applied') === '1') return;
    img.setAttribute('data-fallback-applied', '1');
    img.src = fallbackSrc;
  }

}
